import React from 'react';
import styles from './ProductPage.module.css';
import { useParams, useNavigate } from 'react-router-dom';
import TitleProducts from '../components/TitleProducts/TitleProducts';
import ImageGallery from '../components/ImageGallery/ImageGallery';
import ProductCards from '../components/ProductCards/ProductCards';
import InfoCardsMagicBento from '../components/InfoCardsMagicBento/InfoCardsMagicBento';
import DownloadCatalog from '../components/DownloadCatalog/DownloadCatalog';
import { useProduct } from '../hooks/useProduct';

const categoryTitles = {
  nitrilo: 'Guantes Nitrilo',
  esteriles: 'Guantes Estériles',
  domesticos: 'Guantes Domésticos',
  pe: 'Guantes PE',
  vinilo: 'Guantes Vinilo',
  'natural-latex': 'Guantes Natural Latex',
};

export default function ProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { product, loading, error } = useProduct(id);

  if (loading) {
    return (
      <div className={styles.pageContainer}>
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '80px 20px',
          minHeight: '400px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #8ec9c3',
            borderTop: '4px solid #c9298e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className={styles.pageContainer}>
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#ff6b6b' }}>
          <h2>Producto no encontrado</h2>
        </div>
      </div>
    );
  }

  // Use product's category for title and badges
  const category = product.category || 'nitrilo';
  const categoryTitle = categoryTitles[category] || 'Guantes';

  // Badge config per category
  const badgeConfig = {
    nitrilo: [
      { text: 'NITRILO', className: styles.badgeNitrilo },
      { text: 'Latex Free', className: styles.badgeLatexFree },
    ],
    esteriles: [
      { text: 'ESTÉRIL', className: styles.badgeEsteril },
    ],
    domesticos: [
      { text: 'DOMÉSTICOS', className: styles.badgeDomesticos },
    ],
    pe: [
      { text: 'PE', className: styles.badgePE },
    ],
    vinilo: [
      { text: 'VINILO', className: styles.badgeVinilo },
    ],
    'natural-latex': [
      { text: 'NATURAL LATEX', className: styles.badgeNaturalLatex },
    ],
  };
  const badges = badgeConfig[category] || [];

  return (
    <div className={styles.pageContainer}>
      <TitleProducts title={categoryTitle} />
      <div className={styles.productBox}>
        <div className={styles.leftCol}>
          <ImageGallery images={product.images || [product.image]} />
        </div>
        <div className={styles.rightCol}>
          <div className={styles.badges}>
            {badges.map(b => (
              <span key={b.text} className={b.className}>{b.text}</span>
            ))}
          </div>
          <h1 className={styles.title}>{product.title}</h1>
          <div className={styles.price}>${typeof product.price === 'number' ? Math.round(product.price) : product.price || '-'}</div>
          <div className={styles.priceNote}>Consulte cotización mayorista o instituciones</div>
          <div className={styles.sizesLabel}>Talles</div>
          <div className={styles.sizesRow}>
            {product.sizes?.map(size => (
              <span key={size} className={styles.sizeBox}>{size}</span>
            ))}
          </div>
          <div className={styles.productInfo}>
            {product.subtitle}
          </div>
          <div className={styles.descLabel}>Descripción:</div>
          <div className={styles.descText}>{product.description}</div>
          <div className={styles.actionsRow}>
            {/* Botón "Comprar ahora" comentado */}
            {/* <a
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.buyBtn}
              style={{ textDecoration: 'none', display: 'inline-block' }}
            >
              Comprar ahora
            </a> */}
            <button className={styles.consultBtn} onClick={() => navigate('/contacto')}>
              Consultar
            </button>
          </div>
        </div>
      </div>
      <h2 className={styles.sectionTitle}>Categorías de guantes</h2>
      <ProductCards />
      <InfoCardsMagicBento />
      <DownloadCatalog />
    </div>
  );
}
